import isPointInPolygon from 'robust-point-in-polygon';
import {
	CUBE_LARGE_ISO,
	CUBE_SIZE_LARGE,
	CUBE_SIZE_SMALL,
	CUBE_SIZE_SMALL_CORNER,
	CUBE_SIZE_TALL,
	CUBE_SIZE_TALL_CORNER,
	CUBE_SIZE_WIDE, CUBE_SMALL_ISO, CUBE_TALL_ISO, CUBE_WIDE_ISO
} from './global-constants';

export class ExportedBoxMath {
	public readonly isoFrontAngleSin: number = 0.17708474032;
	public readonly isoFrontAngleCos: number = 0.98419560796;
	public readonly isoFrontAngleTg: number = 0.17992839927;
	public readonly isoFrontFa: number = this.isoFrontAngleTg;
	public readonly isoSideAngleTg: number = 0.56577277818;

	public getCubeSize(cube): any {
		const size = cube.getAttr('cube_size');

		return size;
	}

	public isPointInsidePolygon(x, y, polygon): boolean {
		// ray-casting algorithm based on
		// https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

		let inside = false;
		for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
			const xi = polygon[i].x, yi = polygon[i].y;
			const xj = polygon[j].x, yj = polygon[j].y;

			const intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);

			if (intersect)
				inside = !inside;
		}

		return inside;
	};

	public isPointInsidePolygon2(x, y, polygon): boolean {
		const adaptedPoint = [x, y];
		const adaptedPoly = polygon.map(p => [p.x, p.y]);

		const is = isPointInPolygon(adaptedPoly, adaptedPoint);

		return is === 0 || is === -1;
	}

	public isPointInsideRectangle(x1, y1, x2, y2, x, y):boolean {
		if (x > x1 && x < x2 && y > y1 && y < y2)
			return true;

		return false;
	}

	public isUnderBox(currentBox, box): boolean {
		const safetyCheck = 3;
		const currentCube = this.getCubeCornersFromBox(currentBox);
		const cube = this.getCubeCornersFromBox(box);

		const polygon = [{
			x: cube.tfl.x,
			y: cube.tfl.y
		}, {
			x: cube.tbl.x,
			y: cube.tbl.y
		}, {
			x: cube.tbr.x,
			y: cube.tbr.y
		}, {
			x: cube.bbr.x,
			y: cube.bbr.y
		}, {
			x: cube.bfr.x,
			y: cube.bfr.y
		}, {
			x: cube.bfl.x,
			y: cube.bfl.y
		}];

		if (this.isPointInsidePolygon2(currentCube.tbl.x + safetyCheck, currentCube.tbl.y + safetyCheck, polygon)){
			return true;
		}

		if (this.isPointInsidePolygon2(currentCube.tbr.x, currentCube.tbr.y, polygon)){
			return true;
		}

		if (this.isPointInsidePolygon2(currentCube.bbr.x - safetyCheck, currentCube.bbr.y - safetyCheck, polygon)){
			return true;
		}

		// const x1 = box.attrs.x, y1 = box.attrs.y;
		// const x2 = box.attrs.x + box.attrs.width, y2 = box.attrs.y + box.attrs.height;

		// if (isPointInsideRectangle(x1, y1, x2, y2, currentCube.tbl.x + safetyCheck, currentCube.tbl.y + safetyCheck)) {
		//     return true;
		// }
		//
		// if (isPointInsideRectangle(x1 - safetyCheck, y1 - safetyCheck, x2 + safetyCheck, y2 + safetyCheck, currentCube.tbr.x, currentCube.tbr.y)) {
		//     return true;
		// }
		//
		// if (isPointInsideRectangle(x1, y1, x2, y2, currentCube.bbr.x - safetyCheck, currentCube.bbr.y - safetyCheck)) {
		//     return true;
		// }

		return false;
	}

	public getIsoFa(): number {
		return this.isoFrontFa;
	}

	public getIsoFb(x: number, y: number): number {
		return y - this.isoFrontFa * x;
	}

	public getIsoCos(): number {
		return this.isoFrontAngleCos;
	}

	public getIsoFrontTg(): number {
		return this.isoFrontAngleTg;
	}

	public getIsoSideTg(): number {
		return this.isoSideAngleTg;
	}

	public getIsoFbForCubeTopFrontLine(cube): number {
		const fb = cube.tfl.y - this.isoFrontFa * cube.tfl.x;

		return fb;
	}

	public getIsoFbForCubeTopBackLine(cube): number {
		const fb = cube.tbl.y -this. isoFrontFa * cube.tbl.x;

		return fb;
	}

	public getIsoFbForCubeBottomFrontLine(cube): number {
		const fb = cube.bfl.y - this.isoFrontFa * cube.bfl.x;

		return fb;
	}

	public getIsoFbForCubeBottomBackLine(cube): number {
		const fb = cube.bbr.y - this.isoFrontFa * cube.bbr.x;

		return fb;
	}

	public getIsoFbForBoxTopFrontLine(box): number {
		const cube = this.getCubeCornersFromBox(box);

		const fb = cube.tfl.y - this.isoFrontFa * cube.tfl.x;

		return fb;
	}

	public getIsoCubeOriginFrom2DCubeOrigin(box): { x: number, y: number } {
		// const size = exportedBoxUtils.getCubeSize(box);
		const distanceFromOrigin = box.attrs.x;

		const cubeX = distanceFromOrigin * this.isoFrontAngleCos;
		const cubeY = box.attrs.y + distanceFromOrigin * this.isoFrontAngleSin;

		return {
			x: cubeX,
			y: cubeY
		};
	}

	public getApproximation(val): number {
		//return Math.round(val);
		return +val.toFixed(1);
	}

	public get2DCubeOriginFromIsoBox(box): { x: number, y: number } {
		// const fb = exported.getIsoFbForBoxTopFrontLine(box);
		//
		// const x = exported.getApproximation(box.attrs.x);
		// const y = exported.getApproximation(fb);

		const originDistances = this.getIsoDistanceFromOrigin(box);

		const x = originDistances.tfl;
		const y = originDistances.originY;

		return {
			x,
			y
		}
	}

	public getIsoImgOriginFromIsoCubeOrigin(size, x, width, y, height): { x: number, y: number } {
		let imgX = x, imgY;

		switch (size) {
			case CUBE_SIZE_SMALL:
			case CUBE_SIZE_SMALL_CORNER:
				imgY = y - CUBE_SMALL_ISO.tflY * height;
				break;
			case CUBE_SIZE_TALL:
			case CUBE_SIZE_TALL_CORNER:
				imgY = y - CUBE_TALL_ISO.tflY * height;
				break;
			case CUBE_SIZE_WIDE:
				imgY = y - CUBE_WIDE_ISO.tflY * height;
				break;
			case CUBE_SIZE_LARGE:
				imgY = y - CUBE_LARGE_ISO.tflY * height;
				break;
		}

		return {
			x: imgX,
			y: imgY
		};
	}

	public getIsoDistanceFromOrigin(box): { originX: number, originY: number, tfl: number, tfr: number } {
		const cube = this.getCubeCornersFromBox(box);

		const fb = this.getIsoFbForBoxTopFrontLine(box);

		const originX = 0;
		const originY = fb;

		const distances = {
			originX: originX,
			originY: originY,
			tfl: this.getDistanceFromPoint(originX, originY, cube.tfl.x, cube.tfl.y),
			tfr: this.getDistanceFromPoint(originX, originY, cube.tfr.x, cube.tfr.y)
		};

		return distances;
	}

	public getCubeCornersFromProps(cubeSize, boxX, boxWidth, boxY, boxHeight) {
		if (cubeSize === CUBE_SIZE_SMALL || cubeSize === CUBE_SIZE_SMALL_CORNER) {
			return {
				tfl: {
					x: boxX,
					y: boxY + CUBE_SMALL_ISO.tflY * boxHeight,
					dTop: CUBE_SMALL_ISO.tflY * boxHeight
				},
				tfr: {
					x: boxX + CUBE_SMALL_ISO.tfrX * boxWidth,
					y: boxY + CUBE_SMALL_ISO.tfrY * boxHeight
				},
				tbl: {
					x: boxX + CUBE_SMALL_ISO.tblX * boxWidth,
					y: boxY
				},
				tbr: {
					x: boxX + boxWidth,
					y: boxY + CUBE_SMALL_ISO.tbrY * boxHeight
				},
				bfl: {
					x: boxX,
					y: boxY + CUBE_SMALL_ISO.bflY * boxHeight,
					dTop: CUBE_SMALL_ISO.bflY * boxHeight,
					dBottom: (1 - CUBE_SMALL_ISO.bflY) * boxHeight
				},
				bfr: {
					x: boxX + CUBE_SMALL_ISO.bfrX * boxWidth,
					y: boxY + boxHeight
				},
				bbr: {
					x:boxX + boxWidth,
					y: boxY + CUBE_SMALL_ISO.bbrY * boxHeight
				}
			};
		}

		if (cubeSize === CUBE_SIZE_WIDE) {
			return {
				tfl: {
					x: boxX,
					y: boxY + CUBE_WIDE_ISO.tflY * boxHeight,
					dTop: CUBE_WIDE_ISO.tflY * boxHeight
				},
				tfr: {
					x: boxX + CUBE_WIDE_ISO.tfrX * boxWidth,
					y: boxY + CUBE_WIDE_ISO.tfrY * boxHeight
				},
				tbl: {
					x: boxX + CUBE_WIDE_ISO.tblX * boxWidth,
					y: boxY
				},
				tbr: {
					x: boxX + boxWidth,
					y: boxY + CUBE_WIDE_ISO.tbrY * boxHeight
				},
				bfl: {
					x: boxX,
					y: boxY + CUBE_WIDE_ISO.bflY * boxHeight,
					dTop: CUBE_WIDE_ISO.bflY * boxHeight,
					dBottom: (1 - CUBE_WIDE_ISO.bflY) * boxHeight
				},
				bfr: {
					x: boxX + CUBE_WIDE_ISO.bfrX * boxWidth,
					y: boxY + boxHeight
				},
				bbl: {
					x: boxX + CUBE_WIDE_ISO.bblX * boxWidth,
					y: boxY + CUBE_WIDE_ISO.bblY * boxHeight
				},
				bbr: {
					x:boxX + boxWidth,
					y: boxY + CUBE_WIDE_ISO.bbrY * boxHeight
				}
			};
		}

		if (cubeSize === CUBE_SIZE_TALL || cubeSize === CUBE_SIZE_TALL_CORNER) {
			return {
				tfl: {
					x: boxX,
					y: boxY + CUBE_TALL_ISO.tflY * boxHeight,
					dTop: CUBE_TALL_ISO.tflY * boxHeight
				},
				tfr: {
					x: boxX + CUBE_TALL_ISO.tfrX* boxWidth,
					y: boxY + CUBE_TALL_ISO.tfrY * boxHeight
				},
				tbl: {
					x: boxX + CUBE_TALL_ISO.tblX * boxWidth,
					y: boxY
				},
				tbr: {
					x: boxX + boxWidth,
					y: boxY + CUBE_TALL_ISO.tbrY * boxHeight
				},
				bfl: {
					x: boxX,
					y: boxY + CUBE_TALL_ISO.bflY * boxHeight,
					dTop: CUBE_TALL_ISO.bflY * boxHeight,
					dBottom: (1 - CUBE_TALL_ISO.bflY) * boxHeight
				},
				bfr: {
					x: boxX + CUBE_TALL_ISO.bfrX * boxWidth,
					y: boxY + boxHeight
				},
				bbr: {
					x: boxX + boxWidth,
					y: boxY + CUBE_TALL_ISO.bbrY * boxHeight
				}
			};
		}

		if (cubeSize === CUBE_SIZE_LARGE) {
			return {
				tfl: {
					x: boxX,
					y: boxY + CUBE_LARGE_ISO.tflY * boxHeight,
					dTop: CUBE_LARGE_ISO.tflY * boxHeight
				},
				tfr: {
					x: boxX + CUBE_LARGE_ISO.tfrX * boxWidth,
					y: boxY + CUBE_LARGE_ISO.tfrY * boxHeight
				},
				tbl: {
					x: boxX + CUBE_LARGE_ISO.tblX * boxWidth,
					y: boxY
				},
				tbr: {
					x: boxX + boxWidth,
					y: boxY + CUBE_LARGE_ISO.tbrY * boxHeight
				},
				bfl: {
					x: boxX,
					y: boxY + CUBE_LARGE_ISO.bflY * boxHeight,
					dTop: CUBE_LARGE_ISO.bflY * boxHeight,
					dBottom: (1 - CUBE_LARGE_ISO.bflY) * boxHeight
				},
				bfr: {
					x: boxX + CUBE_LARGE_ISO.bfrX * boxWidth,
					y: boxY + boxHeight
				},
				bbr: {
					x: boxX + boxWidth,
					y: boxY + CUBE_LARGE_ISO.bbrY * boxHeight
				}
			};
		}

		return {};
	}

	public getCubeCornersFromBox(box): any {
		const otherCubeSize = this.getCubeSize(box);
		const otherBoxWidth = box.attrs.width;
		const otherBoxHeight = box.attrs.height;
		const otherBoxX = box.attrs.x;
		const otherBoxY = box.attrs.y;
		const cube = this.getCubeCornersFromProps(otherCubeSize, otherBoxX, otherBoxWidth, otherBoxY, otherBoxHeight);

		return cube;
	}

	public getDistanceFromPoint(x1, y1, x2, y2): number {
		const dist = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));

		return dist;
	}

	public ll_dist(b1, b2): number {
		return ( b1.attrs.x - b2.attrs.x );
	}

	public rr_dist(b1, b2): number {
		return ( ( b1.attrs.x + b1.attrs.width ) - ( b2.attrs.x + b2.attrs.width ) );
	}

	public lr_dist(b1, b2): number {
		return ( b1.attrs.x - ( b2.attrs.x + b2.attrs.width ) );
	}

	public rl_dist(b1, b2): number {
		return ( ( b1.attrs.x + b1.attrs.width ) - b2.attrs.x );
	}

	public tt_dist(b1, b2): number {
		return ( b1.attrs.y - b2.attrs.y );
	}

	public bb_dist(b1, b2): number {
		return ( ( b1.attrs.y + b1.attrs.height ) - ( b2.attrs.y + b2.attrs.height ) );
	}

	public tb_dist(b1, b2): number {
		return ( b1.attrs.y - ( b2.attrs.y + b2.attrs.height ) );
	}

	public bt_dist(b1, b2): number {
		return ( ( b1.attrs.y + b1.attrs.height ) - b2.attrs.y );
	}
}
